<template>
    <v-card flat>

        <v-overlay :value="loadingShipmentData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{
                    $route.params.shipmentId === "new" ? "Add new" : activeShipment.name | t
                }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red"
                   v-if="hasPermissionForAction(PermissionsConstants.SHIPMENT, PermissionsConstants.CREATE)">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="handleCloseClick()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab
                    v-for="item in tabs"
                    :key="item"
                    style="text-transform: none !important;"
            >
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <info-edit-tab/>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import InfoEditTab from "./tab-items/general-edit-tab.vue";
import { PermissionsConstants } from "../../permissions";

export default {
    name: "shipment-edit",
    components: { InfoEditTab },

    data() {
        return {
            tab: 0,
            tabs: ["General"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.shipmentId === "new") {
            await this.addNewShipment()
        } else {
            await this.getShipmentData(this.$route.params.shipmentId)
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("ShipmentStore", ["activeShipment", "createdEvent", "loadingShipmentData", "errorMessage", "requestSuccess"]),
        ...mapState(["user"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        },
        submitValid() {
            return this.createdEvent !== null && this.createdEvent.hasOwnProperty('start') && this.createdEvent.hasOwnProperty('end');
        }
    },
    watch: {
        requestSuccess(val) {
            if (val === true) {
                this.$router.push({
                    name: "shipment-list"
                });
            }
        }
    },
    methods: {
        ...mapActions("ShipmentStore", ["getShipmentData", "submitShipmentUpdate"]),
        ...mapMutations("ShipmentStore", ["addNewShipment", "setRequestError", "setErrorMessage"]),
        handleCloseClick() {
            if (this.$route.name === "shipment-edit" && this.$route.params.shipmentId !== "new") {
                this.$router.push({ name: "shipment-view", params: { shipmentId: this.$route.params.shipmentId } });
            } else {
                this.$router.push({ name: "shipment-list" });
            }
        },
        async submitEdit() {
            if (!this.submitValid) {
                this.setRequestError(true);
                this.setErrorMessage(this.t("Please, fill all the fields"));
                return;
            }

            const payload = {
                ...this.activeShipment,
                start: this.createdEvent.start.format('YYYY-MM-DD HH:mm'),
                end: this.createdEvent.end.format('YYYY-MM-DD HH:mm'),
            };

            try {
                const shipmentId = await this.submitShipmentUpdate(payload);
                if (shipmentId) {
                    this.$router.push({ name: "shipment-view", params: { shipmentId: shipmentId } });
                }
            } catch (error) {
                console.error("Error submitting shipment update:", error);
            }
        }
        ,
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
        }
    }
};
</script>

<style scoped></style>
